import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LoyaltyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"loyalty"}/>
}
